import { cn } from "@/lib/utils";

interface DemoFooterProps {
  children: React.ReactNode;
  className?: string;
  position?: "top" | "bottom";
}

export default function DemoFooter({
  children,
  position = "bottom",
  className,
}: DemoFooterProps) {
  return (
    <div
      className={cn(
        "flex min-h-15.25 w-full shrink-0 items-center justify-center bg-gray-100 px-4 py-3",
        position === "top"
          ? "border-preview-border border-b"
          : "border-preview-border border-t",
        className
      )}
    >
      {children}
    </div>
  );
}
